import { render, staticRenderFns } from "./RecentlyCalledContracts.vue?vue&type=template&id=6a9d9572&scoped=true"
import script from "./RecentlyCalledContracts.vue?vue&type=script&lang=js"
export * from "./RecentlyCalledContracts.vue?vue&type=script&lang=js"
import style0 from "./RecentlyCalledContracts.vue?vue&type=style&index=0&id=6a9d9572&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9d9572",
  null
  
)

export default component.exports